import React from 'react'

import { Filters } from './Filters'
import { GamesGrid } from './Grid'
import { MobileDialog } from './MobileDialog'
import { Box } from './styles'

export function GamesList() {
  return (
    <Box>
      <Filters />
      <MobileDialog />
      <GamesGrid />
    </Box>
  )
}
